import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { type UiEngagementSpec } from 'Pages/combinedFilterFormPage/filterConditionTypes'
import EngagementIcon from './EngagementIcon'

const StyledPlaceholder = styled.span`
  color: var(--silver02);
  cursor: pointer;
  opacity: 1 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const StyledSelected = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
`

const StyledLabel = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

interface EngagementSelectedOptionProps {
  selection?: {
    label: string
    value: UiEngagementSpec['Value']
  }
  placeholder: string
}

const EngagementSelectedOption: FC<EngagementSelectedOptionProps> = ({
  selection,
  placeholder,
}) => {
  if (selection === undefined) {
    return <StyledPlaceholder>{placeholder}</StyledPlaceholder>
  }

  return (
    <StyledSelected>
      <EngagementIcon score={selection.value} />

      <StyledLabel>{selection.label}</StyledLabel>
    </StyledSelected>
  )
}

export default EngagementSelectedOption
